module.exports = __webpack_public_path__ + "img/15.7e39dca0.jpg";